<template>
  <div class="container-fluid p-4">
    <span style="display: none">test version 1.0</span>
    <div class="row">
      <div class="col-12">
        <div class="card shadow-sm border-0">
          <div class="card-body text-center" style="padding: 100px 0;">
            <div class="mb-4">
              <i class="fa fa-tachometer fa-4x text-muted"></i>
            </div>
            <h2 class="text-muted mb-3">Dashboard</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
</style>